<template>
  <div class="page_container goodsManagePage">
    <div class="breadcrumb flex-rowl">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/manage' }"
          >业务资源管理（客户管理）</el-breadcrumb-item
        >
        <el-breadcrumb-item>客户服务管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <!-- 主要内容 start -->
    <div class="main_container">
      <div class="operation_wrap flex-between">
        <div class="screen_wrap flex-rowl">
          <div class="sort_wrap flex-rowc" @click="handleSotr(1)">
            <span>最近联系</span>
            <i class="iconfont icon-24gl-swapHorizontal"></i>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleSotr(2)">
            <span>成交记录</span>
            <i class="iconfont icon-24gl-swapHorizontal"></i>
          </div>
          <div class="select_wrap flex-rowc">
            <el-select
              v-model="params.info_tag_id"
              @change="getCustomerList"
              placeholder="客户标签"
            >
              <el-option
                v-for="item in customerOptin"
                :key="item.id"
                :label="item.labelname"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </div>
          <!-- <div class="select_wrap flex-rowc">
            <el-cascader
              :options="options"
              :props="{ checkStrictly: true }"
              clearable
            ></el-cascader>
          </div> -->
        </div>
        <div class="filter flex-rowr">
          <div class="search_wrap flex-between">
            <el-input
              v-model="params.keyword"
              placeholder="输入关键字查找→"
              @keyup.enter.native="getCustomerList()"
            ></el-input>
            <div class="search_btn flex-rowc" @click="getCustomerList">
              <i class="iconfont icon-chazhaotubiao"></i>
            </div>
          </div>
          <div class="sort_wrap flex-rowc" @click="handleRest">
            <span>重置显示客户服务列表</span>
            <i class="iconfont icon-shuaxin"></i>
          </div>
        </div>
      </div>
      <div
        class="list_wrap"
        v-loading="loading"
        element-loading-text="加载中"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.4)"
      >
        <template v-if="dataList.length > 0">
          <div class="item_wrap" v-for="(item, index) in dataList" :key="index">
            <div class="item_main_wrap flex-rowl">
              <div class="content_wrap flex-between">
                <div class="intro_box flex-rowl" @click="handleDetail(item.id)">
                  <div class="block">
                    <p>
                      客户名称：
                      <span>{{ item.info_truename ? item.info_truename : item.ext_name }}</span>
                    </p>
                    <p>
                      企业名称：
                      <span>{{ item.other_companystr }}</span>
                    </p>
                    <p>
                      职务：
                      <span>{{ item.other_job }}</span>
                    </p>
                    <p>客户标签： <span>{{item.info_tag_idstr}}</span></p>
                    <!-- <p class="customer_wrap" v-if="item.info_tag_idstr">
                      <span class="customer_item">{{
                        item.info_tag_idstr
                      }}</span>
                    </p> -->
                  </div>
                  <div class="block">
                    <p class="red">
                      补充分类：
                      <span>{{ item.other_typestr }}</span>
                    </p>
                    <p class="red">
                      客户属性：
                      <span>{{ item.other_attrstr }}</span>
                    </p>
                    <p class="red">
                      联系优先度：
                      <span>{{ item.other_yxdstr }}</span>
                    </p>
                    <p class="red">
                      成交记录：
                      <!-- <span>￥9999999.99</span> -->
                    </p>
                  </div>
                  <div class="block address_wrap">
                    <p>所在地区：</p>
                    <p>
                      <span>{{ item.other_provincename }}</span>
                      <span>{{ item.other_cityname }}</span>
                      <span>{{ item.other_areaname }}</span>
                    </p>
                    <p>
                      <span>{{ item.other_address }}</span>
                    </p>
                  </div>
                  <div class="block">
                    <p class="red">
                      当前客户归属：
                      <span>{{ item.info_remark }}</span>
                    </p>
                    <p class="red">
                      最新触达日期：
                      <span>{{ item.createdate | formatDate }}</span>
                    </p>
                    <p>
                      最近联系情况：
                      <span>{{ item.getstatestr }}</span>
                    </p>
                    <p>
                      联系结果：
                      <span>{{ item.resultdstr }}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
        <el-empty description="暂无数据" v-else></el-empty>
      </div>
    </div>
    <!-- 主要内容 end -->

    <!-- 分页 start -->
    <div class="pagination_wrap flex-rowc">
      <el-pagination
        @current-change="handleCurrentChange"
        layout="prev, pager, next, jumper"
        :page-size="10"
        :total="listTotal"
      >
      </el-pagination>
    </div>
    <!-- 分页 end -->
  </div>
</template>

<script>
import { getCustomerList, getCustomerLabel, encryptstringadd } from "../../api/api";
import { mapState } from "vuex";
export default {
  name: "serviceIndex",
  data() {
    return {
      type: 1,
      dataList: [],
      loading: false,
      params: {
        pageindex: 1,
        pagesize: 10,
        orderlink: "", // 最近联系的排序 = 1 升序 2 降序
        orderamount: "", // 成交金额的排序 = 1 升序 2 降序（该字段暂不生效）
        info_tag_id: "", //
        keyword: "",
        info_userid: '',  // 企业员工的openid
      },
      listTotal: 0,

      // 客户标签
      customerOptin: [],
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      }else {
        return date
      }
    },
  },
  created() {
    this.params.info_userid = this.$store.state.USERINFO.openid 
    this.getCustomerLabel();
    this.getCustomerList();
  },
  methods: {
    // 分页
    handleCurrentChange(e) {
      this.params.pageindex = e;
      this.getCustomerList();
    },
       // 重置数据
    handleRest() {
      this.params.pageindex = 1
      this.params.keyword = ''
      this.params.orderlink = ''
      this.params.orderamount = ''
      this.params.info_tag_id = ''
      this.getCustomerList()
    },
    // 获取数据
    getCustomerList() {
      this.loading = true;
      getCustomerList(this.params).then((res) => {
        this.dataList = res.list;
        this.listTotal = res.total;
        this.loading = false;
      });
    },
    // 获取客户标签
    getCustomerLabel() {
      let params = {
        pageindex: 1,
        pagesize: 100,
        keyword: "",
      };
      getCustomerLabel(params).then((res) => {
        let newItem = [
          {
            id: "",
            labelname: "客户标签",
          },
        ];
        this.customerOptin = newItem.concat(res.list);
      });
    },

    // 排序
    handleSotr(type) {
      if (type == 1) {
        this.params.orderlink = this.params.orderlink == 1 ? 2 : 1;
      } else {
        this.params.orderamount = this.params.orderamount == 1 ? 2 : 1;
      }
      this.getCustomerList();
    },
     handleDetail(id) {
      // this.$router.push(`/resourceIndex/rServiceDetail/${id}`);
      this.encryptstringadd('rServiceDetail', {id})
    },
     // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  .operation_wrap {
    .screen_wrap {
      font-size: 14px;
      .sort_wrap {
        border: 1px solid #d8d8d8;
        border-radius: 20px;
        height: 35px;
        padding: 0 10px;
        margin-right: 10px;
        cursor: pointer;
      }
      .select_wrap {
        margin-right: 10px;
      }
      .icon-24gl-swapHorizontal {
        transform: rotate(90deg);
      }
    }
  }
  .list_wrap {
    .item_main_wrap {
      .address_wrap {
        width: 28%;
      }
      .customer_wrap {
        span {
          height: 40px;
          border: 1px solid #d2d2d2;
          font-size: 12px;
          padding: 0 10px;
          margin-right: 5px;
          &:last-child {
            margin-right: 0;
          }
        }
      }
      .intro_box {
        cursor: pointer;
      }
    }
    .red {
      color: #ff0036;
    }
  }
}
</style>